// extracted by mini-css-extract-plugin
export var error = "Signup-module--error--2i5Wa";
export var formContainer = "Signup-module--formContainer--bjM5S";